<template>
    <div></div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "GroupPageDefault",
        computed: {
            ...mapGetters('groupPage', {viewer_state: 'viewer_state'}),
        },
        created() {
            if (this.viewer_state.is_member) {
                // https://trello.com/c/D2B4egZH/504-clicking-on-a-community-group-should-take-you-to-group-activity-not-about-page-it-works-like-this-from-circle-groups
                this.$router.replace({...this.$route, name: 'groupDetailPage-activity'});
            }else{
                this.$router.replace({...this.$route, name: 'groupDetailPage-story'});
            }
        }
    };
</script>